import request from '@/utils/request'
import {
    MedicalBusinessWebFormRegisterRequest,
  MedicalBusinessWebFormRegisterResponse
} from '@/interface/api'
import { AlertModule } from '@/store/modules/alert'

const prefix = 'api/v3/customer/web-form/angfaraica'

export const createWebFormInfo = (
  medicalBusinessId: string,
  clinicId: string,
  medicalWebFormInfo: MedicalBusinessWebFormRegisterRequest
): Promise<MedicalBusinessWebFormRegisterResponse> =>
  request({
    url: `${prefix}/${medicalBusinessId}/${clinicId}/`,
    method: 'post',
    data: medicalWebFormInfo
  })
    .then(res => {
      const response: MedicalBusinessWebFormRegisterResponse = {
        result: true,
        message: '',
        id: res.data.data.attributes.t_treatment_web_form_reservation_id
      }
      return response
    })
    .catch(e => {
      AlertModule.SetErrorAlert({
        errorTime: new Date(),
        message: '予約登録に失敗しました。'
      })
      const response: MedicalBusinessWebFormRegisterResponse = {
        result: false,
        message: 'error',
        id: ''
      }
      return response
    })
